import { setGetPartnersByIdAction } from '../action';
import { getPartnersById } from '../api/getPartnersById';

export const setGetPartnersById = (params, callback) => {
    return async (dispatch, getState) => {
        try {
            const {data} = await getPartnersById(params);

            dispatch(setGetPartnersByIdAction(data.data))

            if (callback) {
                callback();
            }
        } catch(error) {
            if (error?.response?.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}